import { skipConstructorLayout } from "../skipConstructorLayout.js";
function useSkipConstructorLayout(layout, data) {
  if (data) {
    return skipConstructorLayout(layout, data);
  }
  return layout;
}
export {
  useSkipConstructorLayout
};
